import React from 'react';
import RacerTimeRow from '../leaderboard/RacerTimeRow';
import './podium.css'

export const Podium = ({racers, showAllTimes, setShowAllTimes}) => {
	let first, second, third;
	
	if(racers[0]){
		const {user, timeString} = racers[0];
		first = <RacerTimeRow rank={1} userName={user} timeString={timeString} />;
	}

	if(racers[1]){
		const {user, timeString} = racers[1];
		second = <RacerTimeRow rank={2} userName={user} timeString={timeString} />;
	}

	if(racers[2]){
		const {user, timeString} = racers[2];
		third = <RacerTimeRow rank={3} userName={user} timeString={timeString} />;
	}

	return <div>
		<h3>Podium</h3>
		<div className='racePodium'>
			{first}
			{second}
			{third}
		</div>
		<div className='showAllTimes'>
			{
				showAllTimes ? 
				<div onClick={() => setShowAllTimes(false)}>Hide Leaderboard</div> : 
				<div onClick={() => setShowAllTimes(true)}>Show Leaderboard</div>
			}
		</div>
	</div>
}